var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sprite-map",staticStyle:{"display":"none"}},_vm._l((_vm.sprites),function(sprite,index){return _c('div',{key:index,domProps:{"innerHTML":_vm._s(sprite)}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }